import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <h2 className="section-title">About</h2>
      <div className="about-content">
        <div className="about-main">
          <div className="about-image-container">
            <img 
              src="/jeff-lassiter.jpg" 
              alt="Jeff Lassiter" 
              className="about-image"
            />
          </div>
          <div className="about-text">
            <p>
              I transform AI models through systematic evaluation and actionable feedback. With 15+ years 
              spanning customer support, QA, analytics, and CIO-level digital transformation, I bring a 
              unique perspective: AI outputs must work in real business scenarios, not just pass technical tests.
            </p>
            <p>
              My approach combines technical precision with business practicality. I evaluate reasoning chains, 
              identify patterns across large datasets, and generate feedback that improves model performance 
              by 20-30% in follow-up iterations. Every evaluation is designed to be useful, actionable, 
              and aligned with real-world needs.
            </p>
          </div>
        </div>
        <div className="about-skills">
          <h3>Core Competencies</h3>
          <ul>
            <li>AI Response Evaluation & Ranking</li>
            <li>Chain-of-Thought Analysis</li>
            <li>Content Improvement & Editing</li>
            <li>Data Categorization & Organization</li>
            <li>Prompt Engineering</li>
            <li>Quality Assurance & Systematic Review</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;

